var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatAlertBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3156 10.3141V24.0723C31.3156 25.9367 29.8032 27.4474 27.9388 27.4474H19.9472L16.1578 32.5C16.1578 32.5 14.1384 29.807 12.3599 27.4373H4.37682C2.51241 27.4373 1 25.9249 1 24.0605V7.24379C1 5.37938 2.51241 3.86865 4.37682 3.86865H24.8685",
    stroke: "#433AC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4626 10.6052C32.2531 10.6052 34.5152 8.34307 34.5152 5.5526C34.5152 2.76212 32.2531 0.5 29.4626 0.5C26.6722 0.5 24.41 2.76212 24.41 5.5526C24.41 8.34307 26.6722 10.6052 29.4626 10.6052Z",
    fill: "#838EF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAlertBlue);
export default __webpack_public_path__ + "static/media/chat-alert-blue.c9e1c0d63dc91d5a48d936f1e9055c90.svg";
export { ForwardRef as ReactComponent };